// https://vuex.vuejs.org/en/actions.html

import countryService from '@/services/countryService'
import contentService from '@/services/contentService'
import store from '@/store'

var isPolling = false
var messageCount = 0

var poll = async function () {
  isPolling = true
  while (store.state.general.pollingEntities.length > 0) {
    console.log('waiting to run over pollingList')
    await new Promise(resolve => setTimeout(resolve, 12000))

    for (var i = store.state.general.pollingEntities.length - 1; i >= 0; i--) {
      var entity = store.state.general.pollingEntities[i]
      console.log('processing polling entity', entity)
      try {
        await store.dispatch(entity.dispatch, entity.dispatchParam)
        if (await store.dispatch(entity.checkup, entity.checkupParam)) {
          console.log('referenced polling entity update success', entity)
          store.commit('removePollingEntity', entity)
          store.dispatch('SetSnackBarMessage', {
            message: entity.succesMessage,
            color: 'success',
          })
        } else {
          store.commit('reducePollingEntity', entity)
        }
      } catch {

      }
    }
  }
  isPolling = false
}

export default {
  async RefreshCountries (context) {
    var loadingId = await store.dispatch('AddLoadingMessage', 'Loading Countries')
    var apiResult = await countryService.get()
    if (apiResult.success) {
      context.commit('refreshCountries', apiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },

  async AddPollingEntity (context, entity) {
    console.log('adding polling entity', entity)
    if (context.commit('addPollingEntity', entity) === false) {
      return
    }

    if (isPolling) {
      return // we are already polling
    }

    // start the polling
    console.log('starting polling', entity)
    await poll()
  },
  AddLoadingMessage (context, text) {
    context.commit('addLoadingMessage', { id: messageCount, text: text })
    messageCount++
    return messageCount - 1
  },
  RemoveLoadingMessage (context, id) {
    context.commit('removeLoadingMessage', id)
  },
  async RefreshSupportPage (context) {
    var loadingId = await store.dispatch('AddLoadingMessage', 'Loading support info')
    var apiResult = await contentService.getSupport()
    if (apiResult.success) {
      context.commit('refreshSupportInfo', apiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },

  async AddActivity (context, type, id) {
    context.commit('addActivity', { type: type, id: id, notifications: [] })
  },

  async AddNotification (context, notification) {
    context.commit('addNotification', notification)
  },

  async MarkNotificationsAsRead (context, notification) {
    context.commit('markNotificationAsRead', notification)
  },
}
